const Actions = self => ({
    incrementCredits: () => {
        self.shouldShowBulkUBP() && self.bulkShowCredits--;
    },
});
export default Actions;
